import apiClient from 'services/axios'
import store from 'store'

const ACCESS_TOKEN = 'ACCESS_TOKEN'

export function clearToken() {
  return store.remove(ACCESS_TOKEN)
}

export function getToken() {
  const accessToken = store.get(ACCESS_TOKEN)
  if (accessToken) {
    apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`
  }
  return accessToken
}

export default function storeToken(accessToken) {
  if (accessToken) {
    store.set(ACCESS_TOKEN, accessToken)
    apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`
  }
  return accessToken
}
